import debounce from 'lodash.debounce'
import { getQueryParamsFromFormData } from '~/helpers/routing'

export default

	computed:
		formData: -> @$store.state.globals.data
		currentStep: -> @$store.state.globals.currentStep
	routeName: -> @$route.name

	methods:

		# Write our form data to URL params so it can be copied and shared
		writeFormDataToUrl: (path) ->

			queryParams = getQueryParamsFromFormData
				formData: @formData
				dataConfig: @$store.state.globals?.dataConfig

			options = { query: queryParams }
			options.path = path if path?
			await @$router.push options

		readFormDataFromUrl: ->
			{ query } = @$route
			return unless query

			# Convert to booleans
			if query.consentToCommunicate?
				query.consentToCommunicate = (query.consentToCommunicate=='true' ? true : false)
			if query.consentToProcess?
				query.consentToProcess = (query.consentToProcess=='true' ? true : false)

			# Set form data
			@$store.commit 'globals/setData', query
			@$store.commit 'globals/setAppState', {key: 'inittedFormDataFromUrl', value: true}

		removeFormDataFromUrl: -> @$router.push {query: null}
